var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script-choose',{ref:"editor",attrs:{"options":_vm.options,"propValue":_vm.propValue,"validateArg":_vm.validateArg,"dataId":_vm.dataId},on:{"change":_vm.changeHandle,"afterChoose":_vm.afterChooseHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }